import {getData} from "../api/get-data";

export const setDeleteCart = (itemId, resolveHandler) => {
  getData({
    [`set_cart`]: {
      [`item_id`]: itemId,
      [`action`]: `delete`,
    }
  })
  .then((response) => {
    resolveHandler(response);
  });
};
